import { CartDrawerRelatedProducts as RecoveredCartDrawerRelatedProducts } from 'vl-recovered/cart-drawer-related-products'
import { replaceNodeChildren } from 'src/scripts/utils/dom'
import { $el, $list } from 'src/scripts/utils/utils'
import { hasCartDrawerAsideProducts } from './cart-drawer-aside-state'

const IN_CART_RELATED_PRODUCTS_SELECTOR = '[in-cart-related-product]'

export class CartDrawerRelatedProducts extends RecoveredCartDrawerRelatedProducts {
  updateByHTML = node => {
    // RecoveredCartDrawerRelatedProducts.updateByHTML is an instance arrow
    // field, so it is not available through super. Repeat the small original
    // update contract here before applying the split-only aside state sync.
    const recommendations = $el(`#${this.id}`, node)
    replaceNodeChildren(this, recommendations)

    const products = $list(IN_CART_RELATED_PRODUCTS_SELECTOR, this)
    this.setReady(products.length > 0)

    const cartDrawer = this.closest('.cart-drawer')
    cartDrawer?.toggleAttribute(
      'has-aside-products',
      hasCartDrawerAsideProducts(node),
    )
  }
}
